import { combine, withSnakeCaseKeys } from '@datadog/browser-core';
/**
 * Internal context keep returning v1 format
 * to not break compatibility with logs data format
 */
export function startInternalContext(applicationId, session, parentContexts, configuration) {
    return {
        get: function (startTime) {
            if (configuration.isEnabled('v2_format')) {
                var viewContext = parentContexts.findViewV2(startTime);
                if (session.isTracked() && viewContext && viewContext.session.id) {
                    var actionContext = parentContexts.findActionV2(startTime);
                    return withSnakeCaseKeys(combine({ applicationId: applicationId }, { sessionId: viewContext.session.id, view: viewContext.view }, actionContext ? { userAction: { id: actionContext.action.id } } : undefined));
                }
            }
            else {
                var viewContext = parentContexts.findView(startTime);
                if (session.isTracked() && viewContext && viewContext.sessionId) {
                    return withSnakeCaseKeys(combine({ applicationId: applicationId }, viewContext, parentContexts.findAction(startTime)));
                }
            }
        },
    };
}
//# sourceMappingURL=internalContext.js.map